module.exports = __webpack_public_path__ + "static/lights16-18b89da240c9e3571934eb37a861f28d.jpg";